import React from 'react'
import { Route, Routes } from 'react-router-dom'
import Amount from '../app/pages/amount/Amount'
import ConfirmTransaction from '../app/pages/confirm-transaction/ConfirmTransaction'
import Error from '../app/pages/error/Error'
import FailedTransaction from '../app/pages/failed-transaction/FailedTransaction'
import Goals from '../app/pages/goals/Goals'
import Organizations from '../app/pages/organizations/Organizations'
import Rules from '../app/pages/rules/Rules'
import Thanks from '../app/pages/thanks/Thanks'

const AppRoutes = () => {
  return (
    <div>
      <Routes>
        <Route path="/platnosc/niepowodzenie" element={<FailedTransaction />} />
        <Route path="/platnosc/powodzenie" element={<Thanks />} />
        <Route path=":locationCode" element={<Organizations />} />
        <Route path=":locationCode/:organizationId" element={<Goals />} />
        <Route
          path=":locationCode/:organizationId/:goalId/kwota"
          element={<Amount />}
        />
        <Route
          path=":locationCode/:organizationId/:goalId/regulamin"
          element={<Rules />}
        />
        <Route
          path=":locationCode/:organizationId/:goalId/potwierdzenie"
          element={<ConfirmTransaction />}
        />

        <Route path="/blad" element={<Error />} />
        <Route path="/*" element={<Error />} />
      </Routes>
    </div>
  )
}

export default AppRoutes
